import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getFeedsKeywordNew, getOverviewKeywordNew } from '@op/services';
import { useState } from 'react';

export default function useOverviewKeywordData({
  openUserCache,
}: {
  openUserCache?: boolean;
}) {
  const [feedsKeyword, setFeedsKeyword] = useState<any>({});
  const [overviewKeyword, setOverviewKeyword] = useState<any>({});
  const { wrapperCancelRequest, loading: overviewKeywordLoading } =
    useCancelRequestHook();
  function requestTimeline(filter: any) {
    wrapperCancelRequest(
      getOverviewKeywordNew,
      filter,
      false,
      openUserCache ? { user_cache_expire: 5 } : {},
    ).then(data => {
      setOverviewKeyword(data);
    });
  }

  const {
    wrapperCancelRequest: wrapperCancelRequest1,
    loading: feedsKeywordLoading,
  } = useCancelRequestHook();
  function requestCloud(filter: any) {
    wrapperCancelRequest1(
      getFeedsKeywordNew,
      filter,
      false,
      openUserCache ? { user_cache_expire: 5 } : {},
    ).then(data => {
      setFeedsKeyword(data);
    });
  }

  return {
    overviewKeywordLoading,
    feedsKeywordLoading,
    feedsKeyword,
    overviewKeyword,
    requestTimeline,
    requestCloud,
  };
}
